<fui-modal [maxHeight]="maxHeight" [maxWidth]="maxWidth" [state]="open">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()"
                                  [title]="'wbo.web-ordering-item-availability.field-set.manageItemAvailability.manageItemAvailability'"
                                  [titleParams]="{'sellable': sellableName}">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <fui-rows>
                <fui-row [label]="'\'' + sellableName + '\''">
                    <wbo-app-item-availability-edit-form class="content"
                                                                [sellableId]="sellableId"
                                                                [outletGroupId]="outletGroupId"
                                                                [countdowns]="countdowns">
                    </wbo-app-item-availability-edit-form>
                </fui-row>
            </fui-rows>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()"></wbo-cancel-button>
                <wbo-ok-button (click)="ok()"></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
